<script>
import TwitterButton from 'vue-share-buttons/src/components/TwitterButton';
import FacebookButton from 'vue-share-buttons/src/components/FacebookButton';
import moment from 'moment';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import Loader from '../../components/Loader';
import Comments from './Comments';
import ReportModal from '../../components/ReportModal';
import EditDealModal from '../../components/EditDealModal';


export default {
    components: {
        Navbar,
        Footer,
        Loader,
        Comments,
        ReportModal,
        EditDealModal,
        TwitterButton,
        FacebookButton,
    },

    filters: {
        postedTime(createdDate) {
            return moment(createdDate).fromNow();
        },
    },

    props: { id: String },

    metaInfo() {
        return {
            title: this.title,
            description: this.ogDescription,

            meta: [
                { vmid: 'og:title', property: 'og:title', content: this.ogTitle }, 
                { vmid: 'og:type', property: 'og:type', content: 'website' }, 
                { vmid: 'og:description', property: 'og:description', content: this.ogDescription },
                { vmid: 'og:url', property: 'og:url', content: this.ogUrl },
                { vmid: 'og:image', property: 'og:image', content: this.ogImage },
            ],
        };
    },

    data() {
        return {
            isLoading: false,
            isLoadingLike: false,
            deal: {},
            modalOpen: false,
            editModal: false,
            title: 'Share a great deal, earn a great deal',

            ogTitle: null,
            ogDescription: null,
            ogUrl: null,
            ogImage: null,
        };
    },

    computed: {
        discountedPrice() {
            return Math.round(100 - ((this.deal.current_price * 100) / this.deal.rrp));
        },
    },

    async mounted() {
        this.isLoading = true;
        window.scrollTo(0, 0);
        const response = await window.axios.get(`/api/deals/${this.$route.params.id}`);
        this.deal = response.data.data;

        // Set the metadata for the page.
        this.title = this.deal.title;

        // OpenGraph parameters
        this.ogTitle = this.deal.title;
        this.ogDescription = this.deal.description;
        this.ogUrl = window.location.href.split('?')[0];
        this.ogImage = this.deal.image_url;

        // Stop loading icon.
        this.isLoading = false;
    },

    methods: {
        async copyCode(voucherCode) {
            await navigator.clipboard.writeText(voucherCode);
            Vue.toasted.show('Voucher Code copied to clipboard.', { duration: 2000 });
        },

        async copyAndGoTosite(voucherCode) {
            await navigator.clipboard.writeText(voucherCode);
            Vue.toasted.show('Voucher Code copied to clipboard.', { duration: 2000 });

            window.open(this.deal.url, '_blank');
        },

        filterByCategory(category) {
            const cats = JSON.stringify([category]);
            this.$router.push({path:'/', query: { category: cats }});
        },

        filterByRetailer(retailer) {
            this.$store.dispatch('addRetailersFilter', retailer.name);
            this.$router.push('/?resetRetailers=false');
        },

        filterByUser(user) {
            this.$router.push('/?search=' + user);
        },

        isExpired(expiryDate) {
            return moment(expiryDate).isBefore(moment());
        },


        async refreshDeal() {
            this.isLoading = true;
            const response = await window.axios.get(`/api/deals/${this.$route.params.id}`);
            this.deal = response.data.data;
            this.isLoading = false;
        },

        
        /**
         * Like or unlike the deal
         */
        async likeDeal() {
            const likeOrUnlike = this.deal.liked ? 'unlike' : 'like';


            this.isLoadingLike = true;
            let response = null;
            try {
                response = await window.axios.post(`/api/deals/${this.deal.id}/${likeOrUnlike}`);

            } catch (e) {
                this.isLoadingLike = false;
            }
            this.isLoadingLike = false;

            if (response.status < 400) {
                this.deal.liked = !this.deal.liked;

                if (this.deal.liked) {
                    this.deal.star_count += 1;
                } else {
                    this.deal.star_count -= 1;
                }
            }
        },

        async expire() {
            const expireOrUnexpire = this.isExpired(this.deal.ends) ? 'unexpire' : 'expire';
            await window.axios.post(`/api/deals/${this.deal.id}/${expireOrUnexpire}`);
            this.refreshDeal();

            Vue.toasted.show(
                'Deal expiry date updated, thank you for keeping things up to date!', 
                { duration: 4000, icon: 'check' },
            );
        },

    },
};
</script>

<template lang="pug" src="./templates/Deal.pug"></template>
<style lang="stylus" src="./styles/Deal.styl" scoped></style>
